import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// ── Sección pública ───────────────────────────────────────────────────────────
import Index from './pages/Index';
import PaginasInteres from './pages/PaginasInteres';
import Terminos from './pages/Terminos';
import Categorias from './pages/Categorias';
import Tareas from './pages/Tareas';
import ListaTests from './pages/ListaTests';
import TestRunDispatcher from './pages/TestRunDispatcher';
import LegacyRedirect from './pages/LegacyRedirect';
import { AnalyticsTracker } from './lib/analytics';
import EnsayoSecuencias from './pages/EnsayoSecuencias';
import PwaDeviceStatus from './pages/PwaDeviceStatus';

// ── Sección admin ─────────────────────────────────────────────────────────────
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminLenguajes from './pages/admin/AdminLenguajes';
import AdminCategorias from './pages/admin/AdminCategorias';
import AdminTareas from './pages/admin/AdminTareas';
import AdminTests from './pages/admin/AdminTests';
import AdminListas from './pages/admin/AdminListas';
import AdminUsuarios from './pages/admin/AdminUsuarios';
import AdminConfiguraciones from './pages/admin/AdminConfiguraciones';
import AdminEnsayos from './pages/admin/AdminEnsayos';
import AdminLinks from './pages/admin/AdminLinks';
import AdminCarrusel from './pages/admin/AdminCarrusel';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPwaInstalaciones from './pages/admin/AdminPwaInstalaciones';

export default function App() {
  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <Routes>
        {/* ── Pública ── */}
        <Route path="/" element={<Index />} />
        <Route path="/links" element={<PaginasInteres />} />
        <Route path="/terminos" element={<Terminos />} />
        <Route path="/secuencias" element={<EnsayoSecuencias />} />
        <Route path="/dispositivo-prueba" element={<PwaDeviceStatus />} />
        <Route path="/WebFormTest/:page" element={<LegacyRedirect />} />
        <Route path="/lenguaje/:lenguajeId" element={<Categorias />} />
        <Route path="/lenguaje/:lenguajeId/categoria/:categoriaId" element={<Tareas />} />
        <Route
          path="/lenguaje/:lenguajeId/categoria/:categoriaId/tarea/:tareaId"
          element={<ListaTests />}
        />
        <Route
          path="/lenguaje/:lenguajeId/categoria/:categoriaId/tarea/:tareaId/test/:type/:testId"
          element={<TestRunDispatcher />}
        />

        {/* ── Admin ── */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard"  element={<AdminDashboard />} />
          <Route path="pwa"        element={<AdminPwaInstalaciones />} />
          <Route path="ensayos"    element={<AdminEnsayos />} />
          <Route path="lenguajes"  element={<AdminLenguajes />} />
          <Route path="categorias" element={<AdminCategorias />} />
          <Route path="tareas"     element={<AdminTareas />} />
          <Route path="tests"      element={<AdminTests />} />
          <Route path="listas"     element={<AdminListas />} />
          <Route path="links"      element={<AdminLinks />} />
          <Route path="carrusel"   element={<AdminCarrusel />} />
          <Route path="usuarios"   element={<AdminUsuarios />} />
          <Route path="configuraciones" element={<AdminConfiguraciones />} />
        </Route> 
      </Routes>
    </BrowserRouter>
  );
}
